import {
  CountUp,
  EmptyStatePage,
  GlassCard,
  Glyph,
  makeEntrance,
  usePrefersReducedMotion,
} from "@/components/application/empty-state-page";

const INBOX_ICON =
  "M2.5 12h3.382c.685 0 1.312.387 1.618 1 .306.613.933 1 1.618 1h5.764c.685 0 1.312-.387 1.618-1 .306-.613.933-1 1.618-1H21.5M8.967 4h6.066c1.077 0 1.616 0 2.091.164a3 3 0 0 1 1.121.693c.36.352.6.833 1.082 1.796l2.166 4.333c.19.378.284.567.35.765.06.177.102.357.128.541.029.207.029.418.029.841V15.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C19.72 20 18.88 20 17.2 20H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 17.72 2 16.88 2 15.2v-2.067c0-.422 0-.634.029-.84.026-.184.068-.365.128-.541.066-.199.16-.388.35-.766l2.166-4.333c.482-.963.723-1.444 1.082-1.796a3 3 0 0 1 1.12-.693C7.352 4 7.89 4 8.968 4Z";
const ACTIVITY_ICON =
  "M9 14s1.312 1.5 3.5 1.5c2.187 0 3.5-1.5 3.5-1.5m-.75-5h.01M9.75 9h.01m2.74 11a8.5 8.5 0 1 0-8.057-5.783c.108.32.162.481.172.604a.899.899 0 0 1-.028.326c-.03.12-.098.245-.232.494l-1.636 3.027c-.233.432-.35.648-.324.815a.5.5 0 0 0 .234.35c.144.087.388.062.876.011l5.121-.529c.155-.016.233-.024.303-.021.07.002.12.009.187.024.069.016.155.05.329.116A8.478 8.478 0 0 0 12.5 20Zm3.25-11a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-5.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z";

const COUNT_START_MS = 1300;

const STATS: { icon: string; label: string; value: number; caption: string; delay: number }[] = [
  { icon: INBOX_ICON, label: "Inbox", value: 0, caption: "Messages across all creator conversations", delay: 0.35 },
  {
    icon: ACTIVITY_ICON,
    label: "Brand and Creator Activity",
    value: 0,
    caption: "Creators accepted collabs",
    delay: 0.77,
  },
];

export function MessagesActivityEmptyState() {
  const reduceMotion = usePrefersReducedMotion();
  const entrance = makeEntrance(reduceMotion);

  return (
    <EmptyStatePage
      eyebrow="Messages & Activity"
      headline={
        <>
          Every creator touchpoint
          <br />
          in one place
        </>
      }
      subline={[
        "A quiet inbox doesn’t mean a quiet creator. The last sample they requested, the last video they posted, every message in both directions.",
        "Messages and activity appear here as soon as a creator starts interacting with your brand.",
      ]}
      measureCh={46}
      portraitSrc="/empty-states/portrait-messages-activity.webp"
      portraitMaskLeft="22%"
      device={
        <div className="grid w-full max-w-[540px] grid-cols-2 gap-4">
          {STATS.map((stat) => (
            <GlassCard
              key={stat.label}
              radius="xl"
              className="h-full backdrop-blur-3xl"
              style={{ animation: entrance.glassIn(stat.delay) }}
              overlayStyle={{ animation: entrance.fadeIn(stat.delay) }}
            >
              <div className="flex flex-col gap-3 px-5 py-5" style={{ animation: entrance.fadeInUp(stat.delay) }}>
                <span className="flex items-center gap-2.5 text-sm font-semibold text-white/85">
                  <span
                    aria-hidden="true"
                    className="inline-flex size-9 shrink-0 items-center justify-center rounded-lg bg-brand-200 text-unbox-dark-brand-start"
                  >
                    <Glyph d={stat.icon} />
                  </span>
                  {stat.label}
                </span>
                <span className="text-[40px] leading-[46px] font-semibold tracking-[-1.2px] text-white tabular-nums">
                  <CountUp value={stat.value} startDelayMs={COUNT_START_MS} />
                </span>
                <span className="text-sm leading-5 text-brand-100">{stat.caption}</span>
              </div>
            </GlassCard>
          ))}
        </div>
      }
    />
  );
}
